// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__ouuYW","body":"style_body__2u0mF"};